import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import WhoseTurn from "components/WhoseTurn/WhoseTurn";
import { getStudents, selectParentId, hasStudents, setParentId, ParentStudentsSlice } from "src/pods/parentStudents";
import { useSearchParams } from "react-router-dom";

function mapStateToProps(state: ParentStudentsSlice) {
  return {
    parentId: selectParentId(state),
    hasStudents: hasStudents(state),
  };
}

type WhoseTurnPageInnerProps = {
  parentId?: string;
  hasStudents?: boolean;
  dispatch: Dispatch;
};

function WhoseTurnPageInner({ parentId, hasStudents, dispatch }: WhoseTurnPageInnerProps) {
  // this tells i18next to load these namespaces
  const { ready } = useTranslation(["dojo.beyond"]);

  const [params] = useSearchParams();
  const { parentId: parentIdQueryParam } = Object.fromEntries(params.entries());
  // bulk ignore existing useEffects
  // eslint-disable-next-line @web-monorepo/no-useEffect
  useEffect(() => {
    if (parentIdQueryParam && parentIdQueryParam !== parentId) {
      dispatch(setParentId(parentIdQueryParam));
    }
  }, [parentIdQueryParam, dispatch, parentId]);

  // bulk ignore existing useEffects
  // eslint-disable-next-line @web-monorepo/no-useEffect
  useEffect(() => {
    if (parentId && !hasStudents) {
      dispatch(getStudents(parentId));
    }
  }, [parentId, hasStudents, dispatch]);

  if (!ready) return null;

  return <WhoseTurn />;
}

const WhoseTurnPage = connect(mapStateToProps)(WhoseTurnPageInner);
export default WhoseTurnPage;
